import { useNavigate } from 'react-router-dom';

// ✅ Constants
const COMPANY_NAME = 'AastroG';
const CONTACT_PATH = '/contactus';

// ✅ Reusable Components
const SectionTitle = ({ children }) => <h2 className="about-section-title">{children}</h2>;

const TextBlock = ({ children }) => <p className="about-text">{children}</p>;

const List = ({ items }) => (
  <ul className="about-list">
    {items.map((item, index) => (
      <li key={index} className="about-list-item">{item}</li>
    ))}
  </ul>
);

function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="about-container">
      <h1 className="heading">About Us</h1>

      <TextBlock>
        At <strong>{COMPANY_NAME}</strong>, we're building the future of astrology by combining the timeless
        wisdom of Vedic Jyotish with the precision of Artificial Intelligence. Our goal is to make
        astrology highly personalized, interactive, and accessible for everyone.
      </TextBlock>

      <SectionTitle>What Makes Us Different</SectionTitle>
      <TextBlock>Unlike traditional astrology platforms, {COMPANY_NAME} offers:</TextBlock>
      <List
        items={[
          <><strong>Highly Personalized Chat</strong> → Get instant guidance through our AI + Vedic astrology-powered chat system.</>,
          <><strong>1-on-1 Consultations</strong> → Connect directly with expert astrologers for deeper, human-led insights.</>,
          <><strong>More Features Coming Soon</strong> → We're actively working on advanced reports, remedies, and interactive tools to make your experience even better.</>,
        ]}
      />

      <SectionTitle>We're in Beta – and Growing with You</SectionTitle>
      <TextBlock>
        {COMPANY_NAME} is currently in its <strong>Beta stage</strong>. This means you're among the first to
        experience our vision of AI-powered astrology. While we're refining the platform, we truly
        value your support in shaping it.
      </TextBlock>
      <TextBlock>
        If you find a bug, face a glitch, or have an idea for improvement, please share it with us.
        Every suggestion helps us grow and make {COMPANY_NAME} better for you and the community.
      </TextBlock>

      <SectionTitle>Our Mission</SectionTitle>
      <TextBlock>To merge ancient wisdom with modern intelligence so you can:</TextBlock>
      <List
        items={[
          'Gain clarity in personal and professional decisions',
          'Explore self-awareness through your birth chart',
          'Receive personalized remedies and insights instantly',
          'Connect with experts when you need a deeper consultation',
        ]}
      />

      <SectionTitle>Let's Build Together</SectionTitle>
      <TextBlock>
        We're not just building a platform — we're building a <strong>community</strong>.
      </TextBlock>
      <TextBlock>
        At {COMPANY_NAME}, your feedback is as valuable as the stars themselves. Together, we'll create
        the most personal, powerful, and intelligent astrology platform in the world.
      </TextBlock>

      <hr className="about-divider" />

      <p className="about-footer">
        Join us on this journey •{' '}
        <span
          className="about-link"
          onClick={() => navigate(CONTACT_PATH)}
        >
          Contact Us
        </span>
      </p>
    </div>
  );
}

export default AboutUs;
